<template>
  <form @submit="handleImport($event)">
    <div class="row">
      <div class="col-md-12">
        <LabelRequiredField label="Arquivo" />
        <b-form-file
          name="file"
          :disabled="loading"
          placeholder="SELECIONE OU ARRASTE O ARQUIVO AQUI (LibreOffice Calc, Excel ou CSV)."
          drop-placeholder="SOLTE O ARQUIVO AQUI..."
          browse-text="PROCURAR"
          accept=".xls, .xlsx, .csv, .ods"
          id="file"
        />
      </div>
      <div class="col-md-12 pt-0 pb-0"><ErrorsMessages :errors="errors" /></div>
      <div class="col-md-12 text-right">
        <v-btn :disabled="loading" type="submit" class="btn-save">
          <i class="fas fa-check mr-2 text-twenty"></i>
          {{ loading ? "CARREGANDO" : "IMPORTAR" }}
        </v-btn>
      </div>
    </div>
  </form>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import LabelRequiredField from "../../../Components/LabelRequiredField";

import toast from "../../../../lib/ToastNotification";

import api from "../../../../services/api";

export default {
  name: "Import",
  components: {
    ErrorsMessages,
    LabelRequiredField,
  },
  data() {
    return {
      loading: false,
      errors: [],
    };
  },
  methods: {
    async handleImport(event) {
      try {
        event.preventDefault();

        this.loading = true;

        this.errors = [];

        const formData = new FormData();

        let files = document.getElementById("file").files;

        if (!files) {
          this.loading = false;
          this.errors = ["Informe o arquivo"];
          return;
        }

        if (files.length == 0) {
          this.loading = false;
          this.errors = ["Informe o arquivo"];
          return;
        }

        const allowedMimes = [
          "application/vnd.ms-excel", //(official)
          "application/msexcel",
          "application/x-msexcel",
          "application/x-ms-excel",
          "application/x-excel",
          "application/x-dos_ms_excel",
          "application/xls",
          "application/x-xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
        ];

        for (const file of files) {
          if (!allowedMimes.includes(file.type)) {
            this.loading = false;
            this.errors = ["Formato de arquivo inválido"];
            return;
          }

          var limitSize = 10 * 1024 * 1024;

          if (file.size > limitSize) {
            this.loading = false;
            this.errors = ["Suportado até 10MB"];
            return;
          }

          formData.append("file", file);
        }

        let response = await api.post(
          "/rest-home/financial/configuration/category-import",
          formData
        );

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.$emit("success");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>
